function readBoolean(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined || value.trim() === '') return fallback;
  return value.trim().toLowerCase() === 'true';
}

/**
 * Legacy shared-server tools are useful for deliberate development migration,
 * but must never be exposed by default in a public production build.
 */
export function legacyServerToolsEnabled(
  env: Record<string, string | boolean | undefined> = (import.meta as ImportMeta & {
    env?: Record<string, string | boolean | undefined>;
  }).env ?? {},
): boolean {
  const production = env.PROD === true || env.PROD === 'true';
  const configured = env.VITE_ENABLE_LEGACY_SERVER_TOOLS;
  return readBoolean(
    typeof configured === 'string' ? configured : undefined,
    !production,
  );
}
